import { FC } from 'react';
import { Button, Card, CardContent, CardHeader, Grid, Table, TableBody, Theme, Tooltip, Typography, makeStyles } from '@material-ui/core';
import TableHeader from './components/TableHeader';
import TableBodySchedule from './components/TableBodySchedule';
import TableFooter from './components/TableFooterSchedule';
import EditIcon from '@material-ui/icons/Edit';
import { ServiceType } from 'constants/enum';

interface Props {
  isLoading: boolean;
  service: ServiceDetailModel;
  isEditable: boolean;
  handleOpenForm(form: string): void;
}

const useStyles = makeStyles((theme: Theme) => ({
  cardHeader: { borderBottom: '1px solid rgba(224, 224, 224, 1)' },
  divider: {
    marginRight: theme.spacing(1)
  }
}));

const ServiceSchedule: FC<Props> = props => {
  const classes = useStyles();
  const { isLoading, service, isEditable, handleOpenForm } = props;
  const { Jobs } = service;
  // Editing the schedule can change the quotation amount, so once the invoice is fully paid it needs the
  // edit-paid-invoice permission (mirrors the backend guard); the save then asks for a password and a reason.
  // (a $0 FULLY PAID invoice, with nothing collected, is not locked)
  const isPaidInvoiceLocked =
    service.invoiceStatus === 'FULLY PAID' && Number(service.invoiceCollectedAmount || 0) > 0 && !service.canEditFullyPaidInvoice;

  return (
    <Card variant='outlined'>
      <CardHeader
        title={
          <Grid container direction='row' justify='space-between' alignItems='center'>
            <Typography variant='h5'>Job Schedules</Typography>
            <Tooltip
              title={
                !isEditable || isPaidInvoiceLocked
                  ? service.serviceType === ServiceType.ADDITIONAL
                    ? 'Cannot edit because this is separate quotation'
                    : 'Cannot edit because the invoice is already fully paid or the quotation is cancelled'
                  : 'Edit schedule only affects jobs that are still unassigned; confirmed, assigned or completed jobs are kept unchanged'
              }
            >
              <span style={{ cursor: !isEditable || isPaidInvoiceLocked ? 'not-allowed' : 'default' }}>
                <Button color='primary' disabled={isLoading || !isEditable || isPaidInvoiceLocked} onClick={() => handleOpenForm('edit schedules')}>
                  <EditIcon />
                  Edit Job Schedules
                </Button>
              </span>
            </Tooltip>
          </Grid>
        }
        className={classes.cardHeader}
      />
      <CardContent style={{ padding: 0 }}>
        <Table component='table'>
          <TableHeader
            headers={[
              { label: 'Job Occurrences', verticalAlign: 'top' },
              { label: 'Job ID', verticalAlign: 'top' },
              { label: 'Start & End Date Time', verticalAlign: 'top' },
              { label: 'Item & Description', verticalAlign: 'top' },
              { label: 'Quantity', verticalAlign: 'top' },
              { label: 'Price', verticalAlign: 'top' },
              { label: 'Job Amount', verticalAlign: 'top' },
              { label: 'Job Status', verticalAlign: 'top' }
            ]}
          />
          <TableBody>
            <TableBodySchedule isLoading={isLoading} Jobs={Jobs} />
          </TableBody>
          <TableFooter isLoading={isLoading} service={service} />
        </Table>
      </CardContent>
    </Card>
  );
};

export default ServiceSchedule;
